'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');
var _classnames2 = _interopRequireDefault(_classnames);
require('./Button.css');
require('./ButtonSkins.css');
var _Icon = require('../Icon/Icon');
var _Icon2 = _interopRequireDefault(_Icon);
var _Tooltip = require('../Tooltip');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/**
 * Different options for buttons.
 */
var Button = function Button(_ref) {
  var id = _ref.id,
    styleType = _ref.styleType,
    iconType = _ref.iconType,
    text = _ref.text,
    size = _ref.size,
    rightIcon = _ref.rightIcon,
    type = _ref.type,
    label = _ref.label,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    block = _ref.block,
    anchor = _ref.anchor,
    tooltip = _ref.tooltip,
    tooltipPlacement = _ref.tooltipPlacement,
    iconSize = _ref.iconSize,
    props = _objectWithoutProperties(_ref, ['id', 'styleType', 'iconType', 'text', 'size', 'rightIcon', 'type', 'label', 'onClick', 'disabled', 'block', 'anchor', 'tooltip', 'tooltipPlacement', 'iconSize']);
  var baseButtonClass = (0, _classnames2.default)('c-button', {
    'c-button--default': styleType === 'default'
  }, {
    'c-button--primary': styleType === 'primary'
  }, {
    'c-button--danger': styleType === 'danger'
  }, {
    'c-button--borderless': styleType === 'borderless'
  }, {
    'c-button--link': styleType === 'link'
  }, {
    'c-button--small': size === 'small'
  }, {
    'c-button--icon': iconType && !text
  }, {
    'c-button--block': block
  });
  var renderContent = function renderContent() {
    return _react2.default.createElement('div', {
      className: 'c-button__content'
    }, iconType && _react2.default.createElement(_Icon2.default, {
      type: iconType,
      large: iconSize === 'large'
    }), text && _react2.default.createElement('div', {
      className: 'c-button__label'
    }, text), !text && label && _react2.default.createElement('div', {
      className: 'u-sr-accessible'
    }, label), rightIcon && _react2.default.createElement(_Icon2.default, {
      type: rightIcon,
      large: iconSize === 'large'
    }));
  };
  var renderButton = function renderButton() {
    if (anchor) {
      return _react2.default.createElement('a', _extends({
        className: baseButtonClass,
        onClick: onClick
      }, props), renderContent());
    } else {
      return _react2.default.createElement('button', _extends({
        id: id,
        className: baseButtonClass,
        onClick: onClick,
        disabled: disabled,
        type: type
      }, props), renderContent());
    }
  };
  var renderButtonWithTooltip = function renderButtonWithTooltip(tooltipText) {
    var overlay = _react2.default.createElement(_Tooltip.Tooltip, {
      id: id ? 'tooltip-' + id : undefined
    }, tooltipText);
    return _react2.default.createElement(_Tooltip.OverlayTrigger, {
      placement: tooltipPlacement,
      overlay: overlay
    }, renderButton());
  };
  if (tooltip) {
    return renderButtonWithTooltip(tooltip);
  } else if (!text && label) {
    return renderButtonWithTooltip(label);
  } else {
    return renderButton();
  }
};
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Style type of button to display. */
  styleType: _propTypes2.default.oneOf(['default', 'primary', 'danger', 'borderless', 'link']),
  /** The html button type of the button */
  type: _propTypes2.default.oneOf(['button', 'submit', 'reset']),
  /** Size of button to display.*/
  size: _propTypes2.default.oneOf(['normal', 'small']),
  /** The type of icon to display in front of text. */
  iconType: _propTypes2.default.string,
  /** Text to display in the in the button. */
  text: _propTypes2.default.string,
  /** Display down caret after the text.*/
  rightIcon: _propTypes2.default.string,
  /** Add label when no text is used. Used by screen readers.*/
  label: _propTypes2.default.string,
  /** Function fired on click.*/
  onClick: _propTypes2.default.func,
  /** Determines whether the button should be disabled */
  disabled: _propTypes2.default.bool,
  /** Stretch the button */
  block: _propTypes2.default.bool,
  /** Use anchor element for the button. */
  anchor: _propTypes2.default.bool,
  /** Text to use explicitly as a tooltip. For buttons without text, the label is automatically used. */
  tooltip: _propTypes2.default.string,
  /** Where to place the tooltip. */
  tooltipPlacement: _propTypes2.default.oneOf(['left', 'top', 'right', 'bottom']),
  /** Size of the icon inside buttons */
  iconSize: _propTypes2.default.oneOf(['normal', 'large'])
} : {};
Button.defaultProps = {
  styleType: 'default',
  size: 'normal',
  type: 'button',
  disabled: false,
  tooltipPlacement: 'bottom',
  iconSize: 'normal'
};
exports.default = Button;